// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1726087298727
      var cssReload = require("D:/ZRTC/node_modules/umi/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  